import { defineMessages } from 'react-intl';

export default defineMessages({
    requests: {
        defaultMessage: 'Requests',
        description: 'Requests item in menu',
        id: 'avatar.menu.v2.header.requests',
    },
    requestListHeading: {
        defaultMessage: 'Requests list',
        description: 'Requests list header in menu request subsection',
        id: 'avatar.menu.v2.header.requests-list',
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in menu request subsection',
        id: 'avatar.menu.v2.header.manage-column',
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'Approvals item in menu',
        id: 'avatar.menu.v2.header.approvals',
    },
    profile: {
        defaultMessage: 'Profile',
        description: 'Profile item in menu',
        id: 'avatar.menu.v2.header.profile',
    },
    logout: {
        defaultMessage: 'Log out',
        description: 'Log out button in menu',
        id: 'avatar.menu.v2.logout',
    },
    topic: {
        defaultMessage: 'Page layout',
        description: 'Topics and Portals in avatar drop-down menu',
        id: 'avatar.menu.v2.topic',
    },
    topicsAndPortals: {
        defaultMessage: 'Topics and portals',
        description: 'Topics and Portals in avatar drop-down menu when advanced customization enabled',
        id: 'avatar.menu.v2.topic.non-final',
    },
    hideAndReorder: {
        defaultMessage: 'Hide and reorder',
        description: 'Hide and reorder item in menu',
        id: 'avatar.menu.v2.hideAndReorder.non-final',
    },
    look: {
        defaultMessage: 'Look and feel',
        description: 'look and feel item in menu',
        id: 'avatar.menu.v2.look',
    },
    announcement: {
        defaultMessage: 'Announcements',
        description: 'announcement item in menu',
        id: 'avatar.menu.v2.announcement',
    },
    signIn: {
        defaultMessage: 'Log in message',
        description: 'sign in message item in menu',
        id: 'avatar.menu.v2.signIn',
    },
    tooltip: {
        defaultMessage: 'Profile and settings',
        description: 'tooltip on avatar',
        id: 'avatar.profile.v2.tooltip',
    },
    reporting: {
        defaultMessage: 'Performance',
        description: 'Navigates to Reporting page',
        id: 'avatar.menu.v2.reporting',
    },
    portalAnnouncement: {
        defaultMessage: 'Announcements',
        description: 'announcement item in menu portal subsection',
        id: 'avatar.menu.v2.portalAnnouncement',
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Portal groups',
        description: 'portal groups item in menu portal subsection',
        id: 'avatar.menu.v2.requestTypeGroup',
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Portal heading for menu portal subsection',
        id: 'avatar.menu.v2.portal.section',
    },
    helpCenter: {
        defaultMessage: 'Help center',
        description: 'Help Center heading for menu multi hc subsection',
        id: 'avatar.menu.v2.helpCenter.section.non-final',
    },
    tooltipNonPremiumTenantCreateHc: {
        defaultMessage: 'You need to upgrade to administer this Help Center. ',
        description: 'Message shown to non premium tenants when they try to create a Help Center',
        id: 'multi-hc-dropdown.manage-hc.tooltip.non.premium.tenant.create.hc.non-final',
    },
    onboardingTitleCreateClick: {
        defaultMessage: 'Serve more customers through additional help centers',
        description: 'Upgrade modal title when create help center is clicked',
        id: 'uh.home.downgrade.modal.title.create.hc.non-final',
    },
    onboardingDescriptionCreateClick: {
        defaultMessage:
            'You can now create more than one help center for different audiences. Upgrade to Jira Service Management Premium plan to create a new help center. ',
        description: 'Upgrade modal description when create help center is clicked',
        id: 'uh.home.downgrade.modal.description.create.hc.non-final',
    },
    onboardingTitleHCClick: {
        defaultMessage: 'Upgrade to access your additional help center',
        description: 'Upgrade modal title when help center is clicked',
        id: 'uh.home.downgrade.modal.title.hc.non-final',
    },
    onboardingDescriptionHCClick: {
        defaultMessage:
            'You have to upgrade to Jira Service Management Premium plan to access and make changes to your additional help centers . ',
        description: 'Upgrade modal description when help center is clicked',
        id: 'uh.home.downgrade.modal.description.hc.non-final',
    },
});
